import { render, staticRenderFns } from "./v-dialog-container.vue?vue&type=template&id=3d93ade2&scoped=true"
import script from "./v-dialog-container.vue?vue&type=script&lang=ts"
export * from "./v-dialog-container.vue?vue&type=script&lang=ts"
import style0 from "./v-dialog-container.vue?vue&type=style&index=0&id=3d93ade2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d93ade2",
  null
  
)

export default component.exports